<template>
    <div>
        <!-- 尾部 -->
    <div class="last">
        <div class="last_box">
          <div class="last_list1">
            <div class="last_img">
              <img src="../../static/img/logo01.png" style="width: 100%;height: 100%;" alt />
            </div>
            <div class="phone_text">咨询热线</div>
            <div class="phone">020-88905678</div>
            <div class="num">股权代码：HK.10065</div>
            <div class="online">
              <a href="http://wpa.qq.com/msgrd?v=3&uin=1273542634&site=qq&menu=yes"
                target="http://wpa.qq.com/msgrd?v=3&uin=1273542634&site=qq&menu=yes"
                style="color:#fff;text-decoration:none">
                <div>在线客服</div>
              </a>
            </div>
          </div>
          <div  class="last_list2">
            <div class="main_text">产品类型</div>
            <div  class="second_box">
              <div>店务系统</div>
              <div class="second_title">供应链商城</div>
              <div class="second_title">营销工具</div>
            </div>
          </div>
          <div class="last_list3">
            <div class="main_text">解决方案</div>
            <div class="second_box">
              <div>店务管理</div>
              <div class="second_title">数据分析</div>
              <div class="second_title">手机开单</div>
              <div class="second_title">营销拓客</div>
              <div class="second_title">精品项目</div>
              <div class="second_title">美业资讯</div>
            </div>
          </div>
          <div  class="last_list3">
            <div class="main_text">美服在线商学院</div>
            <div class="second_box">
              <div>落地干货</div>
              <div class="second_title">线下课程</div>
              <div class="second_title">系统教学</div>
              <div class="second_title">讲师招募</div>
            </div>
          </div>
          <div class="last_list3">
            <div class="main_text">下载中心</div>
            <div class="second_box">
              <div>商户端APP</div>
              <div class="second_title">打印机驱动</div>
              <div class="second_title">远程协助工具</div>
            </div>
          </div>
          <div class="last_list3">
            <div class="main_text">关于我们</div>
            <div class="second_box">
              <div>公司介绍</div>
              <div class="second_title">企业文化</div>
              <div class="second_title">发展历程</div>
              <div class="second_title">公司动态</div>
              <div class="second_title">客户案例</div>
              <div class="second_title">人才招聘</div>
              <div class="second_title">渠道合作</div>
            </div>
          </div>
          <div class="last_list4">
            <div style="margin-left: 3px;">
              <img src="../../static/img/xc.png" alt style="width:88px;height:88px;" />
            </div>
            <div style="font-size:10px;text-align: center;margin-top: 5px;">小程序二维码</div>
            <div style="margin-top: 28px;margin-left: 3px;">
              <img src="../../static/img/gz.png" alt style="width:88px;height:88px;" />
            </div>
            <div style="font-size:10px;text-align: center;margin-top: 5px;">公众号二维码</div>
            <div style="margin-top: 24px">
              <div style="width: 16px;height: 16px;float: left;">
                <img src="../../static/img/WB.png" alt />
              </div>
              <div style="font-size:10px;float: left;">
                <a href="https://weibo.com/p/1006065802467241/home?from=page_100606&mod=TAB&is_all=1#place"
                  target="https://weibo.com/p/1006065802467241/home?from=page_100606&mod=TAB&is_all=1#place"
                  style="text-decoration: none;color:#fff">公司微博链接</a>
              </div>
            </div>
          </div>
        </div>
        <div class="last_box2" v-if="show==7">Copyright 2015-2025 广州市御韵软件有限公司. All rights reserved. <span @click="ahref" class="ahover">粤ICP备15064674号</span> 地址：广东省广州市海珠区江南大道362号达标国际4035室</div>
        <div class="last_box2" v-if="show==2">Copyright 2015-2025 广州市御韵软件有限公司. All rights reserved. <span @click="ahref" class="ahover">粤ICP备15064674号</span> 地址：广东省广州市海珠区江南大道362号达标国际4035室</div>
        <div class="last_box2" v-if="show==8">Copyright 2015-2025 广州市御韵软件有限公司. All rights reserved. <span @click="ahref" class="ahover">粤ICP备15064674号</span> 地址：广东省广州市海珠区江南大道362号达标国际4035室</div>
        <div class="last_box2" v-if="show==3">Copyright 2015-2025 广州市御韵软件有限公司. All rights reserved. <span @click="ahref" class="ahover">粤ICP备15064674号</span> 地址：广东省广州市海珠区江南大道362号达标国际4035室</div>
        <div class="last_box2" v-if="show==5">Copyright 2015-2025 广州市御韵软件有限公司. All rights reserved. <span @click="ahref" class="ahover">粤ICP备15064674号</span> 地址：广东省广州市海珠区江南大道362号达标国际4035室</div>
        <div class="last_box2" v-if="show==6">Copyright 2015-2025 广州市御韵软件有限公司. All rights reserved. <span @click="ahref" class="ahover">粤ICP备15064674号</span> 地址：广东省广州市海珠区江南大道362号达标国际4035室</div>
        <div class="last_box2" v-if="show==4">Copyright 2015-2025 广州市御韵软件有限公司. All rights reserved. <span @click="ahref" class="ahover">粤ICP备15064674号</span> 地址：广东省广州市海珠区江南大道362号达标国际4035室</div>
      </div>
    </div>
</template>
<script>
    export default {
        data() {
            return {
              show:1
            }
        },
        mounted() {
          if(window.location.host=="www.zhaomeiw.com"){
            this.show = 7
          }else if (window.location.host=="www.yuyunrj.com"){
            this.show = 2
          }else if (window.location.host=="www.zhaomeiwang.com"){
            this.show = 8
          }else if (window.location.host=="www.yuyunrj.net"){
            this.show = 3
          }else if (window.location.host=="www.wangxiaojun.cn"){
            this.show = 5
          }else if (window.location.host=="www.ymgmrls.com"){
            this.show = 6
          }else{
            this.show = 4
          }
        },
        methods: {
          ahref(){
            window.open("https://beian.miit.gov.cn")
          }
        }
    }
</script>
<style scoped>
.ahover:hover{
  cursor: pointer;
  color: #57d2c0;
}
</style>


// WEBPACK FOOTER //
// src/page/RMBottomDiv.vue